import { CircularProgress } from "@mui/material";
export const CircularSpinner = ({ size = "1.5rem" }) => {
  return (
    <CircularProgress
      size={size}
      thickness={4}
      style={{ color: "#f46c3c", animationDuration: "1s" }}
    />
  );
};
